import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const PortalAuthContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

export const PortalAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null); // null=checking, false=not auth, object=auth
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/api/portal/me`, { withCredentials: true });
      setCustomer(r.data);
    } catch (err) {
      setCustomer(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/api/portal/auth/login`, { email, password }, { withCredentials: true });
    setCustomer(r.data);
    return r.data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/api/portal/auth/logout`, {}, { withCredentials: true });
    } finally {
      setCustomer(false);
    }
  };

  const setup = async (token, password) => {
    const r = await axios.post(`${API}/api/portal/auth/setup`, { token, password }, { withCredentials: true });
    setCustomer(r.data);
    return r.data;
  };

  return (
    <PortalAuthContext.Provider value={{ customer, loading, login, logout, setup, check }}>
      {children}
    </PortalAuthContext.Provider>
  );
};

export const usePortalAuth = () => {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error('usePortalAuth must be inside PortalAuthProvider');
  return ctx;
};

export default PortalAuthContext;
